export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';

export const forgotPasswordFailure = error => ({
    type: FORGOT_PASSWORD_FAILURE,
    payload: error,
    error: true,
});
